// automatically generated by the FlatBuffers compiler, do not modify

export enum EarthquakeProtectionStatus {
  Normal = 0,
  Run = 1,
  Recall = 2,
  Freeze = 3,
  RecallNextFloor = 4,
  Invalid = 5
}
